import Avisos from '@/repositories/Avisos';

// state
const state = () => ({
  avisos: [],
  avisosOrFalse: false,
  countFetch: 0,
  localAvisos: false,
  alertaAtualizacao: true,
});

// getters
const getters = {
  getAlertaAtualizacao: (state) => {
    return state.alertaAtualizacao
  },
  getAvisos: (state) => {
    return state.avisos
  },
  getAvisosOrFalse: (state) => {
    return state.avisosOrFalse
  },
  getLocalAvisos: (state) => {
    return state.localAvisos
  },
  getCountFetch: (state) => {
    return state.countFetch
  },
};

// mutations
const mutations = {
  SET_ALERTA_ATUALIZACAO (state, bool) {
    state.alertaAtualizacao = bool
  },
  SET_AVISOS (state, avisos) {
    state.avisos = avisos
  },
  SET_AVISOS_OR_FALSE (state, avisosOrFalse) {
    state.avisosOrFalse = avisosOrFalse
  },
  SET_LOCAL_AVISOS (state, localAvisos) {
    state.localAvisos = localAvisos
  },
  SET_COUNT_FETCH (state, countFetch) {
    state.countFetch = countFetch
  },
}

// actions
const actions = {
  async fetchAvisos ({ commit, state }) {
    const dados = await Avisos.getAvisos()
    const dadosOrFalse = dados.length > 0 ? dados : false
    commit('SET_AVISOS', dados)
    commit('SET_AVISOS_OR_FALSE', dadosOrFalse)

    const newCountFetch = state.countFetch + 1
    commit('SET_COUNT_FETCH', newCountFetch)
  },
  updateAviso ({ commit, state }, idAviso) {
    Avisos.updateAviso(idAviso)

    const newAvisos = state.avisos.filter(aviso => aviso.id !== idAviso)

    commit('SET_AVISOS', newAvisos)
  },
  fetchLocalAvisos ({ commit }) {
    const avisos = Avisos.getLocalAvisos()

    commit('SET_LOCAL_AVISOS', avisos)
  },
  setLocalAvisos ({ commit }, avisos) {
    Avisos.setLocalAvisos(avisos)
    let newAvisos = Avisos.getLocalAvisos(avisos)

    commit('SET_LOCAL_AVISOS', newAvisos)
  },
  setAvisos ({ commit }, avisos) {
    Avisos.setAvisos(avisos)
  },
  setAlertaAtualizacao ({ commit }, bool) {
    commit('SET_ALERTA_ATUALIZACAO', bool)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
